import React from 'react';
import { useSelector } from 'react-redux';
import criteria from '../../data/skinAnalysisCriteria.json';
import { recommend, productNameForConcern } from '../../logic/skinAnalysis/recommend';
import './skinAnalysis.css';

// Results panel. Everyone sees the recommended PRODUCTS (1–4, tailored to the
// evaluation); the per-finding breakdown ("why") and the saved skincare plan are
// gated behind account creation.
const Recommendations = ({ results, onSignup, onSavePlan }) => {
  const user = useSelector((s) => s?.auth?.user);
  const intake = useSelector((s) => s?.skinAnalysis?.intake);
  const savedPlan = useSelector((s) => s?.skinAnalysis?.plan);
  const findings = (results && results.findings) || [];

  const picks = recommend(findings, intake);

  return (
    <div className="skin-recs">
      {results && results.summary && <h2 className="skin-recs__summary">{results.summary}</h2>}

      <h3 className="skin-recs__heading">Recommended for you</h3>
      {picks.length === 0 ? (
        <p className="skin-recs__empty">No products to recommend right now — your skin is looking great!</p>
      ) : (
        <div className="skin-recs__grid">
          {picks.map((p) => (
            <a key={p.id} className={`skin-rec-card${p.image ? '' : ' skin-rec-card--line'}`} href={p.url} target="_blank" rel="noopener noreferrer">
              {p.image && <img src={p.image} alt={p.name} />}
              <div className="skin-rec-card__name">{p.name}</div>
              <div className="skin-rec-card__blurb">{p.line}</div>
            </a>
          ))}
        </div>
      )}

      {!user ? (
        <div className="skin-gate">
          <h3 className="skin-gate__title">Here&apos;s your recommended products!</h3>
          <p className="skin-gate__copy">Sign up to see the full breakdown and get your personal skincare plan!</p>
          <button type="button" className="skin-btn skin-btn--primary" onClick={onSignup}>
            Create my account
          </button>
        </div>
      ) : (
        <div className="skin-breakdown">
          <h3 className="skin-recs__heading">Why we recommend these</h3>
          {findings.map((f) => (
            <div className="skin-breakdown__item" key={f.concernId}>
              <div className="skin-breakdown__head">
                <span className={`skin-band skin-band--${f.band}`}>{f.band}</span>
                <strong>{f.label}</strong>
              </div>
              <p>{(f.rationale || '').replace('{product}', productNameForConcern(f.concernId))}</p>
            </div>
          ))}
          {savedPlan ? (
            <div className="skin-plan-saved">✓ Your skincare plan is saved{savedPlan.scheduled ? ' and reminders are on.' : '.'}</div>
          ) : (
            <button type="button" className="skin-btn skin-btn--primary" onClick={onSavePlan}>
              Save my skincare plan
            </button>
          )}
        </div>
      )}

      <p className="skin-disclaimer">{criteria.disclaimer}</p>
    </div>
  );
};

export default Recommendations;
